import { faFlagCheckered } from "@fortawesome/pro-solid-svg-icons/faFlagCheckered";
import { Box } from "@mui/material";
import { CorePermissions } from "app/appPermissions";
import { MprcFormSubHeader, MprcIconButton, MprcIconFa } from "components";
import { MprcCardFilterBox } from "components/filter/MprcCardFilterBox";
import { IconButtonUpload } from "components/iconButtons";
import { IconFilter } from "components/icons";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { ManagedEnrollmentTrainingsListOrderBy } from "generated/CoreApi_v1";
import { useSession } from "providers/SessionProvider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AdvancedFilter, IAdvFilterCommand } from "views/general/AdvancedFilter";
import { FilterCmd } from "views/general/AdvancedFilter/FilterCmd";
import { ImportEnrollsDialog } from "views/lms/enrollment/dialogs/ImportEnrollsDialog";
import { EnrollmentListFilter, useEnrollmentManagementContext } from "views/lms/enrollment/Home/EnrollmentManagementWrapper";

export const Filter: React.FC = () => {

    const { t } = useTranslation("lms");

    const [dialog, setDialog] = useState<any>();

    const { permissionExplorer } = useSession();
    const ctx = useEnrollmentManagementContext();

    ///
    const handleFilter = (data: Partial<EnrollmentListFilter>) => {
        ctx.setFilter(data);
        ctx.setPagination({ page: 1 });
    };

    ///
    const handleImport = () => {
        setDialog(
            <ImportEnrollsDialog
                onClose={() => setDialog(null)}
            />
        );
    };

    ///
    const dropdownOptions = (): IAdvFilterCommand[] => {
        var options: IAdvFilterCommand[] = [
            FilterCmd.Training.topic(1, true),
            FilterCmd.Training.sticker(1),
            FilterCmd.Training.language(1),
            FilterCmd.Training.customField(1),
            FilterCmd.Training.tag(1),

            FilterCmd.Training.nameContain(2),
            FilterCmd.Training.authorContain(2),
            FilterCmd.Training.externalCodeContain(2),

            FilterCmd.Training.contentType(3),

            FilterCmd.Training.optionalAudienceContain(4),
            FilterCmd.Training.requiredAudienceContain(4),
            FilterCmd.Training.inLearnPath(4),

            FilterCmd.Training.createdOn(5),
            FilterCmd.Training.modifiedOn(5),
        ];

        return options;
    };

    ///
    const actions = () => {
        var items: React.ReactNode[] = [];

        if (permissionExplorer.hasOne([CorePermissions.TrainingEnrollmentBatchLoadAll, CorePermissions.TrainingEnrollmentBatchLoadExternal])) {
            items.push(
                <Box mr={3}>
                    <IconButtonUpload
                        title={t("Enrollment.StepTraining.ListTraining.ImportTooltip")}
                        onClick={handleImport}
                    />
                </Box>
            );
        }

        items.push(
            <MprcIconButton
                color={ctx.filter.addCompleted ? "warning" : "muted"}
                onClick={() => handleFilter({ addCompleted: !ctx.filter.addCompleted })}
                title={t("Enrollment.StepTraining.ListTraining.IncludeCompletedTooltip")}
            >
                <MprcIconFa icon={faFlagCheckered} />
            </MprcIconButton>
        );

        return items;
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcCardFilterBox>
            {dialog}
            <AdvancedFilter
                filter={ctx.filter}
                leftDropdowns={[{
                    filterCommands: dropdownOptions(),
                    textOrIcon: <IconFilter />,
                    title: t("shared:AdvFilter.Title")
                }]}
                leftDropdownAlign="end"
                orderMenuOptions={[
                    { text: t("Enrollment.StepTraining.ListTraining.OrderBy.NameText"), value: ManagedEnrollmentTrainingsListOrderBy.Name, group: 1 },
                    { text: t("Enrollment.StepTraining.ListTraining.OrderBy.CreatedOnText"), value: ManagedEnrollmentTrainingsListOrderBy.CreatedOn, group: 1 },
                ]}
                startComponent={
                    <div>
                        <MprcFormSubHeader
                            title={t("Enrollment.StepTraining.ListTraining.Title")}
                        />
                    </div>
                }
                beforeLeftDropdown={actions()}
                onFilterChange={(filter) => {
                    ctx.setPagination({ page: 1 });
                    ctx.setFilter({ ...ctx.filter, ...filter });
                }}
                onError={error => MprcRequestSnackbarErrorReport(error)}
            />
        </MprcCardFilterBox>
    );
};
